/* eslint-disable */
import { Responsive } from '../utils';

/******************* BRIGHTCOVE PLAYER MANAGER *******************
 * Last change: 01/02/2017
 * Author: Marcello Cosentino (cosentino.m2@2mlab.com)
 * Versione: 1.1
 *
 * Manager per gestire i video con il nuovo "Brightcove player" HTML5
 * che va a sostituire il vecchio "Smart Player".

 Esempio di utilizzo:

 <div id="videoContainer_5033477017001"
 class="video-container"
 data-bcp-video-id="4198707055001"
 data-bcp-video-poster="./uploaded/adv/video_poster_adv_2016.jpg"
 data-bcp-video-init
 data-bcp-video-autoplay
 data-bcp-quality-select="true"></div>

 $(function() {
 BCPM.initManager();
 });

 Attributi previsti dal Manager:

 id: è importante che questo id sia unico all'interno della pagina

 data-bcp-video-id: id del video da mostrare
 data-bcp-video-id-xs: id del video da mostrare per il mobile

 data-bcp-video-poster
 data-bcp-video-poster-xs (mobile)
 (opzionale, alternativa a data-bcp-video-init):
 url dell'immagine da mostrare come anteprima. al click su questa inizializzo il video.

 data-bcp-video-init (opzionale, alternativa a data-bcp-video-poster): fa si che il video venga inizializzato al caricamento della pagina
 Nota: se è presente una poster image per il breakpoint corrente, l'attributo data-bcp-video-init viene ignorato.
 data-bcp-video-autoplay (opzionale, da usare insieme a data-bcp-video-init): fa si che, appena il video viene inizializzato, venga fatto l'autoplay

 data-bcp-video-loop (opzionale): imposta il player in loop

 data-bcp-aspect-ratio (opzionale, default: 0.5625 = 16:9):
 data-bcp-aspect-ratio-xs (mobile)
 valore decimale altezza/larghezza che definisce l'aspect ratio del video e che verrà impostata sul container

 data-bcp-quality-select="true" (opzionale): mostra una dropdown per la selezione della qualità del video (altrimenti automatica)
 (nota: non supportato da ambienti in cui l'implementazione di HLS è nativa)

 data-bcp-video-redirecturl (opzionale): se specificata, al termine del video l'utente viene rediretto a questa url
 Al termine del video vengono effettuate le seguenti operazioni:
 - redirect ad un url (se indicata tramite "data-bcp-video-redirecturl")
 - chiusura di un eventuale overlay contenente il video
 - ripristina la poster image al posto del video
 - esce dalla modalità fullscreen (se attivata)

 Per aggiungere sottotitoli o caption è necessario inserire uno o più elementi <track> all'interno del .video-container.
 E' possibile specificare uno di questi come default aggiungendo il relativo attributo.
 Esempio:
 <div id="videoContainer_5033477017001" class="video-container" data-bcp-video-id="4198707055001" data-bcp-video-poster="./uploaded/adv/video_poster_adv_2016.jpg" data-bcp-quality-select="true">
 <track kind="captions" src="http://solutions.brightcove.com/intro.vtt" srclang="en" label="English" default>
 <track kind="captions" src="http://solutions.brightcove.com/intro-jp.vtt" srclang="ja" label="Japanese">
 <track kind="captions" src="http://solutions.brightcove.com/intro-fr.vtt" srclang="fr" label="French">
 </div>

 data-bcp-share-enabled="true" (opzionale):
 Attiva lo share all'interno del player.

 data-bcp-share-title (opzionale):
 Titlo del video usato all'interno dell'overlay per lo share.
 Se non indicato verrà usato il titolo del documento html.

 data-bcp-share-description (opzionale):
 Descrizione del video usato all'interno dell'overlay per lo share.

 data-bcp-share-url (opzionale):
 Url della pagina contenente il video per la quale verrà fatto lo share.
 Se non indicato verrà usata l'url della pagina corrente.
 Nota: questa pagina dovrà contenere i meta tag relativi al video, come indicato dalla documentazione:
 http://docs.brightcove.com/en/video-cloud/brightcove-player/guides/social-media-plugin.html#metatags

 data-bcp-share-embedcode (opzionale):
 Permette di sovrascrivere l'embed code mostrato nell'overlay per lo share.

 data-bcp-audio-off (opzionale):
 Disabilita l'audio del video

 data-bcp-hide-ui (opzionale):
 Se presente, nasconde l'interfaccia del player: barra in basso, play/pause, volume

 * Documentazione ufficiale di brightcove:
 * http://docs.brightcove.com/en/video-cloud/brightcove-player/index.html
 * http://docs.brightcove.com/en/perform/brightcove-player/guides/options.html#inpage
 * http://docs.brightcove.com/en/perform/brightcove-player/reference/api/player.html
 * http://docs.brightcove.com/en/perform/brightcove-player/guides/adding-captions-to-videos.html#pubcode
 * http://docs.brightcove.com/en/video-cloud/brightcove-player/guides/social-media-plugin.html#implementcode
 * https://support.brightcove.com/en/video-cloud/docs/player-feature-comparison#captions
 */

// NAMESPACE: BCPM (BrightCove Player Manager)
var BCPM = BCPM || {};

// TRADUZIONI
// per tradurre queste label definire in pagina un tag <script> dopo l'inclusione di "brightcove-player-manager.js"
// e sovrascrivere le voci dell'array BCPM_translation
var BCPM_translation = new Array();
BCPM_translation['Quality'] = 'Quality: ';
BCPM_translation['Auto'] = 'Auto';
(function ($) {

    /**** PARAMETRI ****/
    //parametri hardcoded relativi al player
    var options = {
        aspectRatio: 0.5625,
        account: '3418428625001',
        player: 'ryhXEqW0f',
        playerJsUrl: '//players.brightcove.net/3418428625001/ryhXEqW0f_default/index.min.js'
    };

    /**** VARIABILI PRIVATE ****/

    var players = [];


    /**** FUNZIONI PUBBLICHE ****/

    $.getScriptWithConflictingAMD = function (url, callbackFunction) {
        jQuery.ajax({
            async: true,
            url: url,
            cache: false,
            success: function (script, textStatus, jqXHR) {
                // To avoid "multipledefine" conflict between the downloaded conflicting AMD script (eg: brigthcove player) and dojo:
                // 1. temporarly empty dojo "define" functionù
            	if (typeof define !== "undefined") {
            		var dojoDefine = define;
                    define = undefined;
	                // 2. execute downloaded conflicting script
	                //   (use apply() because "this" must be the "window" object)
	                (function() {
	                    eval(script);
	                }).apply(window);
	                // 3. restore dojo "define" function
	                define = dojoDefine;
              } else {
                (function() {
                  eval(script);
                }).apply(window);
              }

              // 4. execute callback function after being sure that downloaded script was executed
              callbackFunction(script, textStatus, jqXHR);
            },
            error: function (xhr, textStatus, errorThrown) {
                // Look at the `textStatus` and/or `errorThrown` properties.
            }
        });
    };

    // PREPARE
    // Anticipa, per ogni .video-container, la generazione del markup necessario all'aspect ratio intrinseco e la poster image.
    // La poster image inizialmente sarà non cliccabile e senza icona di play.
    // L'icona di play verrà aggiunta e resa cliccabile solo al caricamento dello script brightcove, a seguito della initManager().
    // Nota: funzione da chiamare una volta sola, prima di initManager.
    BCPM.prepare = function () {
        $('.video-container').each(function () {
            var $videoContainer = $(this);
            prepareVideoContainer($videoContainer);
            initPosterImage($videoContainer, function (e) {
                e.preventDefault();
                initVideo($videoContainer, true);
            });

        });
    }

    // INIT MANAGER
    // Da chiamare una volta sola, al caricamento della pagina.
    // Inizializza tutti i div aventi l'attributo "data-bcp-video-id".
    BCPM.initManager = function () {
        if (typeof bc == "undefined") {
            $.getScriptWithConflictingAMD(options.playerJsUrl, handlePlayerJsLoaded);
        }else{
			handlePlayerJsLoaded();
		}
    };

    // GETTER SINGOLO PLAYER PER ID
    // NOTA: il parametro "id" di getPlayerById deve corrispondere
    // al valore dell'attributo "id" DEL CONTAINER avente classe "video-container"
    BCPM.getPlayerById = function (id) {
        for (var i = 0; i < players.length; i++) {
            if (players[i].id() == 'video_' + id) {
                return players[i];
            }
        }
    };

    // METTE IN PAUSA IL PLAYER relativo all'elemento DOM passato
    BCPM.pausePlayer = function ($videoContainer) {
        var player = BCPM.getPlayerById($videoContainer.attr('id'));
        //controllo se il player � gi� stoppato per evitare di triggerare
        //pi� volte l'evento "pause" sullo stesso player
        if (player && !player.paused()) {
            //quando un video sta per fare pause in automatico (a seguito dell'uscita dal viewport)
            //setto la propriet� pausedAutomatically = true
            //cos� posso identificare eventuali eventi di pause richiesti esplicitamente dall'utente
            //console.log('PAUSE PLAYER: ' + $videoContainer.attr('id') + ' autoplayOnScrollEnabled: ' + $videoContainer.data('autoplayOnScrollEnabled') + ' pausedAutomatically: ' + $videoContainer.data('pausedAutomatically'));
            $videoContainer.data('pausedAutomatically', true);
            //console.log('--> pausedAutomatically: ' + $videoContainer.data('pausedAutomatically'));
            videojs(player.id()).pause();
        }
    }

    // FA PLAY DEL PLAYER relativo all'elemento DOM passato
    BCPM.playPlayer = function ($videoContainer) {
        var player = BCPM.getPlayerById($videoContainer.attr('id'));
        if (player) {
            videojs(player.id()).play();
        }
    }

    /**** FUNZIONI PRIVATE ****/

    // Funzione che prepara il markup del container video passato come parametro.
    // Aggiunge un div piu interno per implementare l'intrinsic aspect ratio (vedi anche css).
    var prepareVideoContainer = function ($videoContainer) {
        var _bpSuffix = Responsive.getCurrentBreakpointName() === 'xs' ? '-xs' : '';
        var aspectRatio = options.aspectRatio;
        var attrAspectRatio = $videoContainer.attr('data-bcp-aspect-ratio' + _bpSuffix);
        if (typeof attrAspectRatio !== 'undefined' && attrAspectRatio != '') {
            aspectRatio = parseFloat(attrAspectRatio);
        }

        var $videoContainerInner = $('<div class="video-container-inner"></div>');
        $videoContainerInner.css('padding-top', (aspectRatio * 100) + '%');
        $videoContainer.empty().append($videoContainerInner);
    };

    // Restituisce l'url della poster image nel caso ce ne sia una da mostrare per il breakpoint corrente, false altrimenti.
    var getPosterImageUrl = function ($videoContainer) {
        var _bpSuffix = Responsive.getCurrentBreakpointName() === 'xs' ? '-xs' : '';
        var attrPosterImageUrl = $videoContainer.attr('data-bcp-video-poster' + _bpSuffix);
        return typeof attrPosterImageUrl !== 'undefined' && attrPosterImageUrl != '' ? attrPosterImageUrl : false;
    };

    var setBackgroundImage = function($videoContainer, $element, imageUrl) {
        // se l'elemento è già nella viewport
        if (isElementInViewport($videoContainer)) {
            // setto subito l'immagine per velocizzare il caricamento nelle fasce above the fold
            $element.css("background-image", "url('" + imageUrl + "')");
        } else {
            // altrimenti ritardo a dopo l'evento di load
            // MIGLIORABILE: introducendo lazyload (caricare solo quando un elemento entra nella viewport)
            $(window).on("load", function() {
                $element.css("background-image", "url('" + imageUrl + "')");
            });
        }
    };

    // INIT POSTER IMAGE
    // genera l'ancora e l'immagine contenente l'immagine di anteprima del video
    // al click su questa, la nascondero e istanzierò l'oggetto video in autoplay
    // NOTA: su mobile la poster image non viene mai mostrata in quanto obbligherebbe l'utente a fare due tap per fare il play
    // Restituisce true nel caso ci sia una poster image da mostrare per il breakpoint corrente, false altrimenti.
    var initPosterImage = function ($videoContainer, clickCallbackFunc) {
        var attrAlternativeImage = $videoContainer.attr('data-bcp-alternative-image-xs');
        if (Responsive.getCurrentBreakpointName() === 'xs' &&  typeof attrAlternativeImage !== 'undefined' && attrAlternativeImage != '') {
            //imposto immagine per mobile al posto del video
            var $alternativeImage = $('<figure class="video-poster video-poster--alternative-image"></figure>');
            setBackgroundImage($videoContainer, $alternativeImage, attrAlternativeImage);
            $videoContainer.find('.video-container-inner').append($alternativeImage);
        } else {
        var attrPosterImageUrl = getPosterImageUrl($videoContainer);
        if (attrPosterImageUrl) {
            var $posterAnchor = $('<a href="#" class="video-poster"><span class="play-icon-white"></span></a>');
            setBackgroundImage($videoContainer, $posterAnchor, attrPosterImageUrl);

            $posterAnchor.on('click', function(e) {
                if ($videoContainer.hasClass('video-container--ready')) {
                    clickCallbackFunc(e);
                }
            });
            $videoContainer.find('.video-container-inner').append($posterAnchor);
            return true;
        }
        return false;
        }
    };

    // Verifico se l'elemento � visibile all'interno della viewport
    var isElementInViewport = function (el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        // se l'elemento è ad esempio in display:none
        // lo considero fuori dalla vieport
        if (!$(el).is(':visible')) {
            return false;
        }

        var rect = el.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) {
            return false;
        }

        // Nota: verifico solo a livello verticale se l'elemento è visibile
        var isAboveViewport = rect.bottom < 0;
        var isBelowViewport = rect.top - (window.innerHeight || document.documentElement.clientHeight) > 0;
        var isInViewport = !isAboveViewport && !isBelowViewport;

        // if ($(el).attr('id') == 'videoContainer_6103772907001') {
        //     console.log('rect: ', rect)
        //     console.log('isAboveViewport: ' + isAboveViewport + ', isBelowViewport: ' + isBelowViewport + ' -> isInViewport: ' + isInViewport);
        // }

        return isInViewport;
    };

    // INIT VIDEO
    // genera il markup del video passato come parametro
    // e inizializza il player ed eventuali eventi associati.
    var initVideo = function ($videoContainer, autoplay) {
        var videoLoopNum = 1;
        var attrAlternativeImage = $videoContainer.attr('data-bcp-alternative-image-xs');
        if ((Responsive.getCurrentBreakpointName() === 'xs' &&  typeof attrAlternativeImage !== 'undefined' && attrAlternativeImage != '')) {
        //imposto immagine per mobile al posto del video
         return;
        }
        if (!$videoContainer.data('videoInitialized')) {
            $videoContainer.data('videoInitialized', true);
            $videoContainer.addClass('initialized');

            var containerId = $videoContainer.attr('id');
            var attrVideoId = $videoContainer.attr('data-bcp-video-id');
            var attrVideoIdXs = $videoContainer.attr('data-bcp-video-id-xs');
            if (typeof attrVideoIdXs !== 'undefined' && attrVideoIdXs != '' && Responsive.getCurrentBreakpointName() === 'xs') {
                attrVideoId =  attrVideoIdXs;
            }
            var attrQualitySelect = $videoContainer.attr('data-bcp-quality-select');
            var attrVideoRedirectUrl = $videoContainer.attr('data-bcp-video-redirecturl');
            var attrShareEnabled = $videoContainer.attr('data-bcp-share-enabled');
            var attrShareTitle = $videoContainer.attr('data-bcp-share-title');
            var attrShareDescription = $videoContainer.attr('data-bcp-share-description');
            var attrShareUrl = $videoContainer.attr('data-bcp-share-url');
            var attrShareEmbedcode = $videoContainer.attr('data-bcp-share-embedcode');
            var attrAudioOff = $videoContainer.attr('data-bcp-audio-off');
            var $trackElements = $videoContainer.find('track');

            // Init variabili usate per disattivare l'autoplay dopo che l'utente ha esplicitamente fatto pause
            if (autoplay) {
                $videoContainer.data('autoplayOnScrollEnabled', true);
                $videoContainer.data('pausedAutomatically', false);
            }

            var autoplay = isElementInViewport($videoContainer) && autoplay;

            var $video = $('<video id="video_' + containerId + '" ' +
                    'data-account="' + options.account + '" ' +
                    'data-player="' + options.player + '" ' +
                    'data-embed="default" ' +
                    'data-video-id="' + attrVideoId + '" ' +
                    'class="video-js" ' +
                    'playsinline ' +
                    (autoplay ? 'autoplay ' : '') +
                    'controls></video>');
            $video.append($trackElements);
            $videoContainer.find('.video-container-inner').empty().append($video);

            // INIT BRIGHTCOVE PLAYER
            // vedi http://docs.brightcove.com/en/perform/brightcove-player/samples/load-player-dynamically.html#bcmethod
            try {
                bc(document.getElementById('video_' + containerId));
            } catch (e) {}

            // LOOP N TIMES VIDEO
            function playVideo(player, numberLimitedLoop) {
                // stop looping the video after numberLimitedLoop times
                if (videoLoopNum < numberLimitedLoop) {
                    // play the video
                    player.play();
                    // increment number of times video played
                    videoLoopNum++;
                }
            }

            // EVENT: PLAYER READY
            // Stop Other Players on the Page when a Video Starts:
            // vedi http://docs.brightcove.com/en/video-cloud/brightcove-player/samples/stop-other-players.html
            videojs('video_' + containerId).ready(function () {
                // assign this player to a variable
                var player = this;

                $(player.el()).find('video').removeAttr('role');

                // Metto a volume zero se richiesto
                if (typeof (attrAudioOff) != undefined && attrAudioOff == '') {
                    player.muted(true)
                }

                // assign and event listener for play event
                player.on('play', function (e) {
                    // determine which player the event is coming from
                    var id = e.target.id;
                    //console.log('ON PLAY: ' + id);
                    // go through the array of players
                    for (var i = 0; i < players.length; i++) {
                    	if (players[i].id() === id) {
                            var $videoContainer = $('#' + id).closest('.video-container');
                            // hide play button
                            $videoContainer.find('.vjs-big-play-button').hide();

                            // on mobile play/pause is triggered by single tap
                            if(isMobile.any()) {
                                $videoContainer.on('click', handleTapControl($(this)));
                            }
                        }
                        // get the player(s) that did not trigger the play event
                        if (players[i].id() != id) {
                            // PAUSE THE OTHER PLAYERS
                            var $videoContainer = $('#' + players[i].id()).closest('.video-container');
                            BCPM.pausePlayer($videoContainer);
                        }
                    }
                });

                player.on('pause', function (e) {
                    // determine which player the event is coming from
                    var id = e.target.id;
                    //console.log('ON PAUSE: ' + id);
                    // go through the array of players
                    for (var i = 0; i < players.length; i++) {
                        // get the player(s) that trigger the pause event
                        if (players[i].id() === id) {
                            var $videoContainer = $('#' + id).closest('.video-container');
                            //console.log('updating: ' + id+ ' autoplayOnScrollEnabled: ' + $videoContainer.data('autoplayOnScrollEnabled') + ' pausedAutomatically: ' + $videoContainer.data('pausedAutomatically'));
                            if ($videoContainer.data('autoplayOnScrollEnabled') === true) {
                                if ($videoContainer.data('pausedAutomatically') === false) {
                                    //setto autoplayOnScrollEnabled = false x far s� che
                                    //da questo momento in poi il video non riparta pi� in automatico
                                    $videoContainer.data('autoplayOnScrollEnabled', false);
                                    //console.log('--> autoplayOnScrollEnabled: false');
                                } else {
                                    //se invece ha pausedAutomatically===true
                                    //resetto pausedAutomatically = false per poter gestire i successivi eventi di pause
                                    $videoContainer.data('pausedAutomatically', false);
                                    //console.log('--> pausedAutomatically: ' + $videoContainer.data('pausedAutomatically'));
                                }
                            }
                        }
                    }
                });

                // push the player to the players array
                players.push(player);
            });


            // EVENT: VIDEO META DATA LOADED
            videojs('video_' + containerId).on('loadedmetadata', function (e1, e2) {
                var selectControl;
                var player = this;
                $videoContainer.data('bcpm-player', player);

                // Scateno un evento di player ready, dove passo anche l'id del player appena inizializzato
                $('.video-container').trigger('BCPM_playerReady', [player.id()]);

                // LOOP
                if ($videoContainer.is('[data-bcp-video-loop]')) {
                    player.loop(true);
                }

                // MANUAL RENDITION SELECTION
                // se data-bcp-quality-select="true" creo una select per la qualità del video
                if (attrQualitySelect) {
                    // Controllo che il Manual Rendition Selection sia supportato dall'ambente corrente (implemento sia HLS che DASH)
                    if (getManualRenditionSelectionSupport(player)) {
                        // display quality select element in controlbar
                        selectControl = createSelectInControlbar($videoContainer);
                        // and add change event listener
                        selectControl.addEventListener('change', changeQuality);
                    }
                }

                // SOCIAL SHARE
                // se "data-bcp-share-enabled="true" attivo lo share del player
                // Nota: il player deve avere il plugin javascript per lo share (impostato da dashboard di brightcove)
                if (attrShareEnabled && typeof player.social !== 'undefined') {
                    if (typeof attrShareTitle === 'undefined' || attrShareTitle === '') {
                        attrShareTitle = document.title;
                    }
                    if (typeof attrShareDescription === 'undefined') {
                        attrShareDescription = false;
                    }
                    if (typeof attrShareUrl === 'undefined' || attrShareUrl === '') {
                        attrShareUrl = document.location.href;
                        //compongo l'url che serve per fare lo share del video
                        //url della pagina + video=url_contenuto_wcm_che_contiene_video
                        /*
                         var sSep = "?";
                         var attrShareUrl = location.href;
                         if (attrShareUrl.indexOf("?") != -1) { var sSep = "&"; }
                         if (attrShareUrl.indexOf("video=") == -1) {
                         attrShareUrl = attrShareUrl + sSep + "video=" + encodeURIComponent(linkContentVideo);
                         }
                         */
                    }
                    if (typeof attrShareEmbedcode === 'undefined') {
                        attrShareEmbedcode = false;
                    }
                    var socialOptions = {
                        "title": attrShareTitle,
                        "url": attrShareUrl,
                        "services": {
                            "facebook": true,
                            "google": true,
                            "twitter": true,
                            "tumblr": true,
                            "pinterest": true,
                            "linkedin": true
                        }
                    };
                    if (attrShareDescription) {
                        socialOptions['description'] = attrShareDescription;
                    }
                    if (attrShareEmbedcode) {
                        socialOptions['embedcode'] = attrShareEmbedcode;
                    }
                    player.social(socialOptions);
                }

            });

            // EVENT: VIDEO ENDED
            // - fa il redirect all'url indicata da "data-bcp-video-redirecturl"
            // - chiudi eventuale overlay contenente il video
            // - ripristina la poster image al posto del video
            // - esce dalla modalità fullscreen
            videojs('video_' + containerId).on('ended', function () {
                var player = $videoContainer.data('bcpm-player');
                var numberLimitedLoop = $videoContainer.attr('data-bcp-video-number-loop');

                // a video finito richiamo il play
                if (numberLimitedLoop) {
                    playVideo(player, numberLimitedLoop);
                }

                if (typeof attrVideoRedirectUrl !== 'undefined' && attrVideoRedirectUrl != '') {
                    document.location.href = attrVideoRedirectUrl;
                } else if ($.magnificPopup) {
                    $.magnificPopup.close();
                }

                initPosterImage($videoContainer, function (e) {
                    e.preventDefault();
                    $videoContainer.data('bcpm-player').play();
                });

                if (!document.fullscreenElement === null) {
                    player.exitFullscreen();
                }
            });
        }
    };

    // register play/pause listener on tap (mobile)
    var handleTapControl = function($videoContainer) {

    };

    // HANDLE PLAYER JS LOADED EVENT
    var handlePlayerJsLoaded = function (data, textStatus, jqxhr) {
        $('.video-container').each(function () {
            var $videoContainer = $(this);

            // rendo cliccabile l'eventuale poster image e mostro l'icona play
            $videoContainer.addClass('video-container--ready');

            //se è presente l'attributo "data-bcp-video-init" (in alternativa a "data-bcp-video-poster")
            //oppure se sono su un dispoistivo mobile
            //allora inizializzo subito il video
            var hasPosterImage = getPosterImageUrl($videoContainer);
            var autoInit = $videoContainer.is('[data-bcp-video-init]');

            if (!hasPosterImage && autoInit) {
                var autoplay = $videoContainer.is('[data-bcp-video-autoplay]');
                initVideo($videoContainer, autoplay);
            }

        });
    };

    // function that adds the HTML select element to the controlbar
    var createSelectInControlbar = function ($videoContainer) {
        var player = $videoContainer.data('bcpm-player');
        if (!player) {
            return;
        }

        var representations = player[getManualRenditionSelectionSupport(player)].representations();

        var newElement = document.createElement('div'),
                // dynamically build the select element
                label,
                selectId,
                selectControl,
                option,
                $spacer;
        // dynamically configure the select element and add options
        newElement.name = 'quality';
        newElement.className = 'selectStyle vjs-control';

        selectId = 'bcp-select-quality-' + $videoContainer.attr('data-bcp-video-id');
        selectControl = document.createElement('select');
        selectControl.id = selectId;

        label = document.createElement('label')
        label.htmlFor = selectId;
        label.innerHTML = BCPM_translation['Quality'];
        newElement.appendChild(label);

        option = document.createElement('option');
        option.value = 'auto';
        option.text = BCPM_translation['Auto'];
        selectControl.appendChild(option);

        var representationsByHeight = getRepresentationsByHeight(representations);

        var optionValues = [];
        // array delle altezze
        for (h in representationsByHeight) {
            optionValues.push(h);
        }
        // ordina l'array delle altezze in modo decrescente
        optionValues.sort(function (a, b) {
            if (parseInt(a) > parseInt(b)) {
                return -1;
            }
            if (parseInt(a) < parseInt(b)) {
                return 1;
            }
            return 0;
        });

        // creo una option della select per ogni altezza
        for (var i = 0; i < optionValues.length; i++) {
            option = document.createElement('option');
            option.value = optionValues[i];
            option.text = optionValues[i] + 'p';
            selectControl.appendChild(option);
        }

        newElement.appendChild(selectControl);
        // get spacer in controlbar and append select element
        $spacer = $videoContainer.find('.vjs-spacer');
        $spacer.css('justify-content', 'flex-end');
        $spacer.append(newElement);
        return selectControl;
    };

    // function that changes rendition quality
    var changeQuality = function (evt) {
        var selectedQuality;
        var setToTrueSet;
        var theSelect = evt.target;
        var theContainer = $(theSelect).closest('.video-container');
        var player = theContainer.data('bcpm-player');
        var enableBandwidths;
        var representations = player[getManualRenditionSelectionSupport(player)].representations();
        var representationsByHeight = getRepresentationsByHeight(representations);

        // get selected quality from HTML select element
        selectedQuality = theSelect.options[theSelect.selectedIndex].value;

        // set either the bottom or top bandwidth array to the desired quality
        enabledBandwidths = representationsByHeight[selectedQuality];

        // loop over each rep and check if it should be enabled
        // if a rep's bandwidth is in the enabled bandwidth array (indexOf is not -1)
        // set enabled to true, otherwise set enabled to false
        representations.forEach(function (rep) {
            if (selectedQuality === 'auto' || enabledBandwidths.indexOf(rep) !== -1) {
                rep.enabled(true);
            } else {
                rep.enabled(false);
            }
        });

    };

    // function that detects the support to HLS or DASH of the current environment
    var getManualRenditionSelectionSupport = function (player) {
        if (typeof player.hls !== 'undefined') {
            return 'hls';
        } else if (typeof player.dash !== 'undefined') {
            return 'dash';
        } else {
            return false;
        }
    };

    // raggruppa le representation in un array associtivo per altezza
    // (dato che ad esempio posso avere più representation 720p, aventi qualità differenti)
    var getRepresentationsByHeight = function (representations) {
        var representationsByHeight = new Array();
        var lengthOfReps = representations.length;

        // raggruppo le representation per 'height'
        for (var i = 0; i < lengthOfReps; i++) {
            var h = representations[i].height + '';
            if (representationsByHeight[h] === undefined) {
                representationsByHeight[h] = [];
            }
            representationsByHeight[h].push(representations[i]);
        }

        return representationsByHeight;
    };

    // Utility copiata da reponsive.js
    var isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        webOS: function () {
            return navigator.userAgent.match(/webOS/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
            return navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
        }
    };

    // inizializzo un listener sullo scroll
    // per innescare il play (nel caso di video in autoplay) quando il video entra nel viewport
    // e mette in pausa quando il video esce dal viewport
    var checkPlayPause = function () {
        var videoInViewportWithAutoplay = [];
        var videoInViewportWithoutAutoplay = [];
        var videoOutViewport = [];
        var videoToBePlayed = null;
        var videoToBeStopped = [];
        var $videos = $('.video-container');

        $videos.each(function (i, el) {
            var $video = $(el);
            if (isElementInViewport($video)) {
                if ($video.is('[data-bcp-video-autoplay]')) {
                    videoInViewportWithAutoplay.push($video);
                } else {
                    videoInViewportWithoutAutoplay.push($video);
                }
            } else {
                videoOutViewport.push($video);
            }
        });

        // se presente, faccio play del primo video nella viewport con autoplay
        if (videoInViewportWithAutoplay.length > 0) {
            //se l'utente ha fatto esplicitamente pausa su questo video
            //non lo faccio più ripartire in automatico
            var $videoContainer = $(videoInViewportWithAutoplay[0]);
            if ($videoContainer.data('autoplayOnScrollEnabled') === true) {
                videoToBePlayed = videoInViewportWithAutoplay[0];
                BCPM.playPlayer(videoToBePlayed);
            }
        }

        // se c'è un video da eseguire faccio stop di eventuali altri video nella viewport
        if (videoToBePlayed) {
            videoToBeStopped = [].concat(videoInViewportWithAutoplay.slice(1), videoInViewportWithoutAutoplay, videoOutViewport);
        } else {
            videoToBeStopped = [].concat(videoOutViewport);
        }

        if (videoToBeStopped.length > 0) {
            videoToBeStopped.forEach(function ($video) {
                BCPM.pausePlayer($video);
            });
        }
    }

    if ($('.video-container').length > 0) {
        if (typeof _ !== 'undefined') {
            $(window).on('scroll', _.throttle(function () {
                checkPlayPause()
            }, 400));
        } else {
            $(window).on('scroll', checkPlayPause);
        }
    }


})(jQuery);

export { BCPM };
